import React, { useEffect } from 'react'

import { Tab, Divider } from 'semantic-ui-react'

import UserForm from './UserForm'
import PasswordForm from './PasswordForm'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../../NavBar/useBreadcrumb'

const AdminAccount = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.settings'),
            link: false,
            path: '/settings',
        }])

    }, [setPaths, t])

    return (
      <Tab.Pane>
          <UserForm/>
          <Divider/>
          <PasswordForm/>
      </Tab.Pane>
    )
}

export default AdminAccount
